import React from "react";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";

import useStyles from "./styles";

const MUIAccordionCustomExpandIcon = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="CustomMui-collapseIconWrapper">
        <RemoveIcon />
      </div>
      <div className="CustomMui-expandIconWrapper">
        <AddIcon />
      </div>
    </div>
  );
};

export default MUIAccordionCustomExpandIcon;
